import { ErrorHandler, Injectable, inject } from '@angular/core';
import { SentryErrorHandler } from '@advisor-ui/app-services';
import { PostHogService } from './posthog.service';

@Injectable()
export class PostHogErrorHandler implements ErrorHandler {
    private readonly posthogService = inject(PostHogService);
    private readonly sentryErrorHandler = inject(SentryErrorHandler);

    handleError(error: unknown): void {
        this.posthogService.posthog.captureException(this.extractError(error));
        this.sentryErrorHandler.handleError(error);
    }

    private extractError(error: unknown): unknown {
        if (error && typeof error === 'object' && 'ngOriginalError' in error) {
            return error.ngOriginalError;
        }

        return error;
    }
}
